import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Card, CardBody, Col, Container, Form, Row } from "reactstrap"
import SButton from "components/Common/Button"
import { useHistory } from "react-router-dom"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import { useDispatch, useSelector } from "react-redux"
import RtwImageAction from "store/rtw-image-resource/actions"
import Skeleton from "react-loading-skeleton"
import TableContainer from "components/newTables/TableContainer"

export default function RWTHandwitternImage() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [params, setParams] = React.useState({
    page: 0,
    size: 10,
  })
  const [pagination, setPagination] = React.useState({
    page: 0,
    size: 10,
  })

  const [filter, setFilter] = useState({ name: "" })

  const columns = React.useMemo(
    () => [
      {
        Header: "RTW画像名",
        accessor: "name",
        defaultCanSort: false,
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(
                  `/master/rtw-handwritten-image/${cell.row.original.id}`
                )
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  React.useEffect(() => {
    dispatch(RtwImageAction.getListPage({ ...params, ...pagination }))
  }, [params, pagination])

  const onChangeFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    setParams({
      ...filter,
      page: 0,
      size: 10,
    })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="RTW手書き画像マスター" breadcrumbList={[]} />

        <Card>
          <CardBody>
            <Row className="mb-3">
              <Col md={3}>
                <TextInputWithLabel
                  label={"RTW画像名"}
                  placeholder={""}
                  value={filter.name}
                  type="text"
                  name="name"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={3} className="d-flex align-content-end flex-wrap">
                <SButton className="mx-2 button" onClick={() => onSearch()}>
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <Row className="mb-3">
                  <Col sm="6" />
                  <Col
                    sm="6"
                    className="d-flex align-items-end justify-content-end"
                  >
                    <SButton
                      className="mx-2 button"
                      onClick={() =>
                        history.push("/master/rtw-handwritten-image/add")
                      }
                    >
                      新規登録
                    </SButton>
                  </Col>
                </Row>
                {store.rtwImage.pageData.loading ? (
                  <Skeleton count={5} />
                ) : store.rtwImage.pageData.data?.content?.length === 0 ? (
                  <h3 className="text-center">No Data to Display</h3>
                ) : (
                  <TableContainer
                    data={store.rtwImage.pageData.data?.content || []}
                    columns={columns}
                    pagination
                    page={pagination.page}
                    size={pagination.size}
                    count={store.rtwImage.pageData.data?.totalPages || 1}
                    setParams={setPagination}
                    params={pagination}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
